
import { defineComponent } from 'vue';
import { ActionTypes } from '@/store/actionTypes';
import { MutationTypes } from '@/store/mutationTypes';
import SvgWrenchWithCircle from '@/components/Icons/SvgWrenchWithCircle.vue';
import SvgLocation from '@/components/Icons/SvgLocation.vue';
import SvgCamera from '@/components/Icons/SvgCamera.vue';
import {
    BannerAlert,
    BannerAlertType,
    BannerAlertIconType,
} from '@/store/types';

export default defineComponent({
    components: {
        SvgWrenchWithCircle,
        SvgCamera,
        SvgLocation,
    },
    props: {
        alert: {
            type: BannerAlert,
            default: undefined,
        },
    },
    methods: {
        closeAlert(): void {
            this.$store.dispatch(ActionTypes.CLEAR_BANNER_ALERT, this.alertId);
        },
        showPermissionsStepsGuide(): void {
            this.$store.commit(
                MutationTypes.SET_PERMISSIONS_STEPS_GUIDE_SHOWN,
                true
            );
        },
    },
    computed: {
        alertMessage(): string {
            return this?.alert?.getFormattedMessage() ?? '';
        },
        alertMessageTitle(): string {
            return this?.alert?.getFormattedMessageTitle() ?? '';
        },
        alertId(): number {
            return this?.alert?.getMessageId() ?? -1;
        },
        alertHasDuration(): boolean {
            return !!this.alert?.getDuration();
        },
        bannerType(): string {
            if (this.alert?.getAlertType() === BannerAlertType.SUCCESS)
                return 'success';

            if (this.alert?.getAlertType() === BannerAlertType.ERROR)
                return 'error';

            return 'default';
        },
        useClockIconType(): boolean {
            return this?.alert?.getIconType() === BannerAlertIconType.CLOCK;
        },
        useExclamationIconType(): boolean {
            return (
                this?.alert?.getIconType() === BannerAlertIconType.EXCLAMATION
            );
        },
        useWrenchIconType(): boolean {
            return this?.alert?.getIconType() === BannerAlertIconType.WRENCH;
        },
        useCheckIconType(): boolean {
            return this?.alert?.getIconType() === BannerAlertIconType.CHECK;
        },
        useLocationIconType(): boolean {
            return this?.alert?.getIconType() === BannerAlertIconType.LOCATION;
        },
        useCameraIconType(): boolean {
            return this?.alert?.getIconType() === BannerAlertIconType.CAMERA;
        },
        useCameraAndLocationType(): boolean {
            return (
                this?.alert?.getIconType() ===
                BannerAlertIconType.CAMERA_AND_LOCATION
            );
        },
        showPermissionBeggingLink(): boolean {
            return (
                this.alert?.getAlertType() === BannerAlertType.PERMISSION_BEG
            );
        },
    },
    watch: {
        alert: {
            handler() {
                const duration = this.alert?.getDuration();
                if (!duration) return;

                setTimeout(() => {
                    this.closeAlert();
                }, duration);
            },
            immediate: true,
        },
    },
});
